import { toISODate } from '@/client/lib/dates';
import { isEntryLocked } from '@/client/lib/timesheets';
import type { RouterOutputs } from '@/client/utils/trpc';
import { DayCard } from './DayCard';

type Entry = RouterOutputs['timesheets']['listEntries'][number];
type Submission = RouterOutputs['timesheets']['listSubmissions'][number];

interface WeekGridProps {
  weekFrom: string;
  entries: Entry[];
  submissions: Submission[];
  onAdd: (date: string) => void;
  onEdit: (entry: Entry) => void;
}

export function WeekGrid({ weekFrom, entries, submissions, onAdd, onEdit }: WeekGridProps) {
  const days: string[] = [];
  const monday = new Date(`${weekFrom}T00:00:00`);
  for (let i = 0; i < 7; i++) {
    const d = new Date(monday);
    d.setDate(monday.getDate() + i);
    days.push(toISODate(d));
  }

  return (
    <div className="flex flex-col gap-3">
      {days.map((date) => (
        <DayCard
          key={date}
          date={date}
          entries={entries.filter((e) => e.date === date)}
          isLocked={isEntryLocked(date, submissions)}
          onAdd={onAdd}
          onEdit={onEdit}
        />
      ))}
    </div>
  );
}
